const links = [
  {
    name: "Home",
    to: "/",
  },
  {
    name: "Listing",
    to: "/listing",
  },
  {
    name: "login",
    to: "/login",
  },
];

export default links;
